'use strict';

(function () {
	if (!customElements.get('sticky-products')) {
		class StickyProducts extends HTMLElement {
			constructor() {
				super();
				this.swiper = null;
				this.slider = this.querySelector('.swiper:not(.card-product__slider)');
				this.items = this.querySelectorAll('.sticky-products__right .grid-main__item');
			}

			connectedCallback() {
					this.initSwiper();
					window.addEventListener('resize', () => this.initSwiper.call(this))
					window.addEventListener('orientationchange', () => this.initSwiper.call(this))
			}

			initSwiper() {
				const windowWidth = window.innerWidth;
				const documentWidth = document.documentElement.clientWidth;
				const minWidth = Math.min(windowWidth, documentWidth);

				if (this.items) {
					this.items.forEach(slide => {
						slide.classList.add('swiper-slide');
					});	
				}
				let { spaceBetween = 16, spaceBetweenPc = 16 } = this.dataset

				if (minWidth <= 989) {
					const slidesPerView = this.items.length >= 3 ? 2.5 : this.items.length;
					const swiperParams = {
						slidesPerView: 1,
						scrollbar: true,
						spaceBetween,
						scrollbar: {
							el: '.swiper-scrollbar',
						},
						breakpoints: {
							640: {
								slidesPerView,
								spaceBetween: spaceBetweenPc,
							}
						},
					}

					this.swiper = new Swiper(this.slider, swiperParams);
				} else {
					if (this.items) {
						this.items.forEach(slide => {
							slide.removeAttribute('style');
							slide.classList.remove('swiper-slide');
						});	
					}

					if (this.swiper) {
						this.swiper.destroy();
						this.swiper = null;
					}
				};
			};
		}


		customElements.define('sticky-products', StickyProducts);
	}
	
})();
